export default {
  steps: {
    discount: 'Descuento',
    mobile_app: 'App móvil',
    business_info: 'Info de empresa',
    create_preview: 'Crear contrato de vista previa',
    preview: 'Vista previa del contrato',
    sign: 'Firmar contrato',
  },
  buttons: {
    back: 'Atrás',
    continue: 'Continuar',
  },
  agreement:
    'Cambiar a anual aplica el {{discount}}% de descuento a tu plan {{plan}}. La facturación continúa mensualmente a {{amount}} por mes con un compromiso de {{months}} meses.',
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    failed_to_switch: 'Error al cambiar a anual',
    switched_to_annual: 'Contrato cambiado a anual 👌',
  },
};
